import { useEffect, useState } from 'react';
import { useRedline } from '@libs/redline';
import { useUser } from '@common/hooks/useUser';

interface dataProps {
  cellphone: { type: 'celular'; warningText: string };
  email: { type: 'e-mail'; warningText: string };
}

const data: dataProps = {
  cellphone: {
    type: 'celular',
    warningText: 'Celular verificado',
  },
  email: {
    type: 'e-mail',
    warningText: 'E-mail alterado',
  },
};

const useUpdateContactData = () => {
  const { email, phone } = useUser();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [showWarning, setShowWarning] = useState<boolean>(false);
  const [flowType, setFlowType] = useState<'cellphone' | 'email' | null>(null);
  const [currentStep, setCurrentStep] = useState<'newInfo' | 'verificationCode'>('newInfo');
  const { track: trackRedline } = useRedline();

  const handleUpdateDateClick = (selectFlowType: 'cellphone' | 'email') => {
    if (flowType !== selectFlowType) setCurrentStep('newInfo');

    trackRedline.userTracking.elementClicked({
      elementType: 'button',
      name: 'update-contact-data',
      text: `Editar ${data[selectFlowType as keyof typeof data].type}`,
      location: window.location.pathname,
    });
    if (showWarning) setShowWarning(false);
    setFlowType(selectFlowType);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (showWarning) {
      setTimeout(() => {
        setShowWarning(false);
      }, 5000);
    }
  }, [showWarning]);

  return {
    isModalOpen,
    setIsModalOpen,
    showWarning,
    setShowWarning,
    flowType,
    currentStep,
    setCurrentStep,
    handleUpdateDateClick,
    data,
    user: { email, phone },
  };
};

export default useUpdateContactData;
